import { IOLITE } from '../types';
export default {
  type: IOLITE,
  service: 'net.iolite.io',
  url: 'https://net.iolite.io',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
